import { Box, Button } from '@chakra-ui/react';
import MyDiv from './holidayCard.style';
import { CustomToast } from '../../../../components';
import { useFetch } from '../../../../hooks/useFetch';
import { useEffect, useState } from 'react';
import { IDepartment } from '../../../Admin/Master/Department/model';
import { IBusinessProcessDropdown } from '../../../Admin/Master/Shift/model';
import { IHolidayDropdown } from '../../../Admin/Master/HolidayMaster/model';
import { MultiSelectMenu } from '../../../../components/MultiSelectMenu/MultiSelectMenu';

const HolidayCard = ({onclose}:{onclose:any}) => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);

  const [holidayOptions, setHolidayOptions] = useState<IHolidayDropdown[]>([]);
  const [businessProcess, setBusinessProcess] = useState<IBusinessProcessDropdown[]>([]);
  const [departments, setDepartments] = useState<IDepartment[]>([]);
  const [selectedHolidayIds, setSelectedHolidayIds] = useState<number[]>([]);
  const [selectedBusinessIds, setSelectedBusinessIds] = useState<number[]>([]);
  const [selectedDepartmentIds, setSelectedDepartmentIds] = useState<number[]>([]);

  const handleSubmit = async () => {
    if (selectedHolidayIds.length === 0) {
      addToast({ message: "Please select at least one Holiday", status: "warning" });
      return;
    }
    if (selectedBusinessIds.length === 0) {
      addToast({ message: "Please select at least one Business Process", status: "warning" });
      return;
    }

    const payload = {
      holidayIds: selectedHolidayIds,
      businessProcessIds: selectedBusinessIds,
      departmentIds: selectedDepartmentIds
    };

    const response = await fetchApi('Hrlense_Holiday/holiday', 'POST', payload, null, '');
    if (response) {
      addToast({ message: "Holiday saved successfully!", status: "success" });
      setSelectedHolidayIds([]);
      setSelectedBusinessIds([]);
      setSelectedDepartmentIds([]);
      onclose();
    }
  };
  const loadHolidayMast = async () => {
    const response = await fetchApi('Dropdown/holiday_Mast', 'GET', null, null, '');
    if (response) setHolidayOptions(response);
  };

  const loadBusinessProcess = async () => {
    const response = await fetchApi('DropDown/businessProcess', 'GET', null, null, '');
    if (response) {
      const updated = [{ business_Process_Id: 0, business_Process_Name: 'All Business Process' }, ...response];
      setBusinessProcess(updated);
    }
  }

  const loadDepartments = async () => {
    const response = await fetchApi('Dropdown/department', 'GET', null, null, '');
    if (response) {
      const updated = [{ id: 0, departmentName: 'All Department' }, ...response];
      setDepartments(updated);
    }
  };

  useEffect(() => {
    loadBusinessProcess();
    loadDepartments();
    loadHolidayMast();
  }, []);

  return (
    <MyDiv>
      <Box>
        <MultiSelectMenu label="Holiday Name" options={holidayOptions} selectedValues={selectedHolidayIds} setSelectedValues={setSelectedHolidayIds} labelKey="holiday_Name" valueKey="id" colorScheme="green" />
        <MultiSelectMenu label="Business Process" options={businessProcess} selectedValues={selectedBusinessIds} setSelectedValues={setSelectedBusinessIds} labelKey="business_Process_Name" valueKey="business_Process_Id" colorScheme="blue" />
        <MultiSelectMenu label="Applicable Department" options={departments} selectedValues={selectedDepartmentIds} setSelectedValues={setSelectedDepartmentIds} labelKey="departmentName" valueKey="id" colorScheme="purple" />
        <Box position="fixed" bottom="24px" right="24px" borderRadius="7px" px={4} py={2}>
          <Button colorScheme="green" onClick={handleSubmit}>
            Save Holiday
          </Button>
        </Box>
      </Box>
    </MyDiv>
  );
};

export default HolidayCard;
